// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footer__KspbK {
  background: var(--color-ink-deep);
  color: var(--color-text-muted-on-dark);
  font-family: var(--font-sans);
  padding: clamp(3rem, 2rem + 4vw, 6rem) var(--gutter) 2rem;
}
.footer_inner__lDqtD {
  max-width: var(--container);
  margin: 0 auto;
  display: grid;
  gap: var(--space-7);
  grid-template-columns: minmax(0, 1fr);
}
.footer_logo__K9BUp {
  height: 5rem;
  width: auto;
  display: block;
}
.footer_about__Ll4Kk {
  margin: var(--space-4) 0;
  max-width: 24rem;
  line-height: 1.6;
  font-size: 0.95rem;
}
.footer_columns__wUds6 {
  display: grid;
  gap: var(--space-6) var(--space-5);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.footer_colTitle__UrmKn {
  margin: 0 0 var(--space-4);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: #fff;
  font-weight: 700;
}
.footer_list__MfrvB {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.6rem;
  font-size: 0.95rem;
}
.footer_link__AFt-r {
  white-space: nowrap;
  color: var(--color-text-muted-on-dark);
  text-decoration: none;
  transition: color 0.2s ease;
}
.footer_link__AFt-r:hover {
  color: var(--kur-amber);
}
.footer_address__RO3o7 {
  line-height: 1.5;
  white-space: nowrap;
}
.footer_legal__DjWJb {
  max-width: var(--container);
  margin: var(--space-7) auto 0;
  padding-top: var(--space-5);
  border-top: 1px solid var(--color-border-on-dark);
  display: grid;
  gap: var(--space-3);
  font-size: var(--text-caption);
}
.footer_social__roCPF > div {
  margin-top: 0;
  text-align: left;
}
.footer_social__roCPF ul {
  justify-content: flex-start;
  margin: 0;
}
.footer_legal__DjWJb p {
  margin: 0;
}
@media (min-width: 768px) {
  .footer_columns__wUds6 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1100px) {
  .footer_inner__lDqtD {
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 2.1fr);
  }
  .footer_columns__wUds6 {
    /* the contact column holds the street address on one line */
    grid-template-columns: repeat(4, minmax(0, 1fr)) max-content;
    column-gap: var(--space-5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FOOTER/footer.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,6BAA6B;EAC7B,yDAAyD;AAC3D;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,gDAAgD;AAClD;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,wDAAwD;EAC1D;EACA;IACE,4DAA4D;IAC5D,4DAA4D;IAC5D,0BAA0B;EAC5B;AACF","sourcesContent":[".footer {\n  background: var(--color-ink-deep);\n  color: var(--color-text-muted-on-dark);\n  font-family: var(--font-sans);\n  padding: clamp(3rem, 2rem + 4vw, 6rem) var(--gutter) 2rem;\n}\n.inner {\n  max-width: var(--container);\n  margin: 0 auto;\n  display: grid;\n  gap: var(--space-7);\n  grid-template-columns: minmax(0, 1fr);\n}\n.logo {\n  height: 5rem;\n  width: auto;\n  display: block;\n}\n.about {\n  margin: var(--space-4) 0;\n  max-width: 24rem;\n  line-height: 1.6;\n  font-size: 0.95rem;\n}\n.columns {\n  display: grid;\n  gap: var(--space-6) var(--space-5);\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.colTitle {\n  margin: 0 0 var(--space-4);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  color: #fff;\n  font-weight: 700;\n}\n.list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 0.6rem;\n  font-size: 0.95rem;\n}\n.link {\n  white-space: nowrap;\n  color: var(--color-text-muted-on-dark);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n.link:hover {\n  color: var(--kur-amber);\n}\n.address {\n  line-height: 1.5;\n  white-space: nowrap;\n}\n.legal {\n  max-width: var(--container);\n  margin: var(--space-7) auto 0;\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--color-border-on-dark);\n  display: grid;\n  gap: var(--space-3);\n  font-size: var(--text-caption);\n}\n.social > div {\n  margin-top: 0;\n  text-align: left;\n}\n.social ul {\n  justify-content: flex-start;\n  margin: 0;\n}\n.legal p {\n  margin: 0;\n}\n@media (min-width: 768px) {\n  .columns {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (min-width: 1100px) {\n  .inner {\n    grid-template-columns: minmax(0, 0.9fr) minmax(0, 2.1fr);\n  }\n  .columns {\n    /* the contact column holds the street address on one line */\n    grid-template-columns: repeat(4, minmax(0, 1fr)) max-content;\n    column-gap: var(--space-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer_footer__KspbK`,
	"inner": `footer_inner__lDqtD`,
	"logo": `footer_logo__K9BUp`,
	"about": `footer_about__Ll4Kk`,
	"columns": `footer_columns__wUds6`,
	"colTitle": `footer_colTitle__UrmKn`,
	"list": `footer_list__MfrvB`,
	"link": `footer_link__AFt-r`,
	"address": `footer_address__RO3o7`,
	"legal": `footer_legal__DjWJb`,
	"social": `footer_social__roCPF`
};
export default ___CSS_LOADER_EXPORT___;
